module.exports = __webpack_public_path__ + "fail.d53f8ddd4a68b24425b06e5fb17f1daf.png";